/**
 * Ukas regning for vaktplanen. Kalenderdager (`YYYY-MM-DD`), ikke tidspunkter: et arrangement står
 * på en dato i huset, og en uke er mandag til søndag uansett hvor leseren sitter. Derfor UTC-regning
 * på datoen alene, som `nextDay` i `ShiftAssignModal`.
 */
import type { Locale } from '@tvitvi/shared';

import { intlTag } from '@/lib/format';

const DAY_MS = 86_400_000;

/** I dag i leserens egen kalender. */
export function todayIso(now: Date = new Date()): string {
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${now.getFullYear()}-${month}-${day}`;
}

export function addDays(day: string, days: number): string {
  return new Date(Date.parse(`${day}T00:00:00Z`) + days * DAY_MS).toISOString().slice(0, 10);
}

/** Mandagen i uka dagen står i. */
export function mondayOf(day: string): string {
  const weekday = new Date(Date.parse(`${day}T00:00:00Z`)).getUTCDay();
  return addDays(day, -((weekday + 6) % 7));
}

/** «28. sep.–4. okt. 2026» — `formatRange` bestemmer skilletegnet og hva som gjentas, per språk. */
export function rangeLabel(from: string, to: string, locale: Locale): string {
  const format = new Intl.DateTimeFormat(intlTag(locale), {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  });
  return format.formatRange(new Date(`${from}T00:00:00Z`), new Date(`${to}T00:00:00Z`));
}

/** «man. 29. sep.» — ukedagen først, fordi planen leses som en uke. */
export function dayLabel(day: string, locale: Locale): string {
  return new Intl.DateTimeFormat(intlTag(locale), {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
  }).format(new Date(`${day}T00:00:00Z`));
}
